import { render, staticRenderFns } from "./pay-link-details.vue?vue&type=template&id=015c09b3"
import script from "./pay-link-details.vue?vue&type=script&lang=js"
export * from "./pay-link-details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports